import AsyncSelect from "react-select/async";

import { MemberSearchProps } from "@models/shared/shared.model";

const MemberSearch = ({
  clearError,
  loadOptions,
  onChangeGuest,
  placeholder,
  selectedGuest,
}: MemberSearchProps) => {
  return (
    <AsyncSelect
      loadOptions={loadOptions}
      placeholder={placeholder}
      className="mb-3 text-start"
      isClearable
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: base => ({
          ...base,
          zIndex: 1090,
        }),
      }}
      value={selectedGuest}
      onChange={guest => {
        onChangeGuest(guest);
        clearError();
      }}
      onInputChange={(inputValue, { action }) => {
        if (action === "input-change") {
          clearError();
        }
        return inputValue;
      }}
    />
  );
};

export default MemberSearch;
